(function () {
  'use strict';

  function money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  var COLOUR_FAMILIES = [
    { key: 'black', aliases: ['black', 'ebony', 'night'] },
    { key: 'turquoise', aliases: ['aqua', 'aquamarine', 'teal', 'turquoise', 'mint', 'petrol'] },
    { key: 'blue', aliases: ['blue', 'navy', 'indigo', 'sky', 'duck egg'] },
    { key: 'red', aliases: ['red', 'scarlet', 'garnet', 'burgundy', 'cherry', 'currant', 'poppy'] },
    { key: 'pink', aliases: ['pink', 'blush', 'rose', 'raspberry', 'fuchsia'] },
    { key: 'green', aliases: ['green', 'sage', 'dusk', 'olive', 'seagrass', 'vetiver'] },
    { key: 'purple', aliases: ['purple', 'violet', 'plum', 'orchid', 'lavender'] },
    { key: 'brown', aliases: ['brown', 'cognac', 'chestnut', 'walnut', 'espresso', 'mocha'] },
    { key: 'beige', aliases: ['beige', 'oat', 'stone', 'almond', 'nude', 'fawn', 'taupe'] },
    { key: 'grey', aliases: ['grey', 'gray', 'granite', 'silver', 'charcoal', 'concrete'] },
    { key: 'yellow', aliases: ['yellow', 'lemon'] },
    { key: 'gold', aliases: ['ochre', 'mustard', 'gold'] },
    { key: 'white', aliases: ['white', 'snow', 'ivory'] }
  ];

  function normaliseColour(value) {
    var normalised = String(value || '').toLowerCase();
    if (normalised.normalize) normalised = normalised.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return normalised.replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function containsColourAlias(value, alias) {
    return (' ' + value + ' ').indexOf(' ' + alias + ' ') !== -1;
  }

  function colourKeys(value) {
    var keys = [];
    String(value || '').split('|').forEach(function (part) {
      var normalised = normaliseColour(part);
      if (!normalised) return;
      var family = COLOUR_FAMILIES.find(function (item) {
        return item.aliases.some(function (alias) { return containsColourAlias(normalised, alias); });
      });
      var key = family ? family.key : normalised;
      if (keys.indexOf(key) === -1) keys.push(key);
    });
    return keys;
  }

  function colourValuesMatch(cardValue, filterValue) {
    var cardKeys = colourKeys(cardValue);
    var filterKeys = colourKeys(filterValue);
    return filterKeys.some(function (key) { return cardKeys.indexOf(key) !== -1; });
  }

  function uniqueProductCards(nodes) {
    var seenProducts = Object.create(null);
    return Array.prototype.slice.call(nodes).filter(function (card) {
      var productId = String(card.dataset.productId || '');
      if (!productId) return true;
      if (seenProducts[productId]) {
        card.remove();
        return false;
      }
      seenProducts[productId] = true;
      return true;
    });
  }

  function addLifestyle(options) {
    if (!window.LifestyleCart) return Promise.reject(new Error('The cart is still loading. Please try again.'));
    return window.LifestyleCart.add(options);
  }

  function notifyCartChanged() {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
      bubbles: true,
      cancelable: false
    }));
  }

  function openSuccess(success, mode) {
    if (!success) return;
    success.querySelectorAll('[data-lj-success-copy]').forEach(function (copy) {
      copy.hidden = copy.dataset.ljSuccessCopy !== mode;
    });
    success.dataset.ljSuccessMode = mode || '';
    success.hidden = false;
  }

  function init(root) {
    if (root.dataset.ljReady === 'true') return;
    root.dataset.ljReady = 'true';

    var mode = root.dataset.ljPdpMode;

    var picker = root.querySelector('[data-lj-picker]');
    var selectors = Array.prototype.slice.call(root.querySelectorAll('[data-lj-open-picker]'));
    var activeSelector = selectors[0] || null;
    var activeSlot = 'first';
    var choices = { first: null, second: null };
    var planningSecondDiscount = Number(root.dataset.ljPlanningSecondDiscount || 50);
    var planningSecondMultiplier = (100 - planningSecondDiscount) / 100;

    if (mode === 'refill') document.body.classList.add('lj-journal-pdp');

    function lockPage(locked) {
      document.body.classList.toggle('lj-pdp-modal-open', locked);
    }

    function getSelectedView(slot) {
      return root.querySelector('[data-lj-selected][data-lj-slot-selected="' + slot + '"]');
    }

    function getSelector(slot) {
      return root.querySelector('[data-lj-open-picker][data-lj-slot="' + slot + '"]');
    }

    function syncPicker(slot) {
      var choice = choices[slot];
      picker.querySelectorAll('[data-lj-card]').forEach(function (card) {
        var cardVariant = card.dataset.selectedVariantId || ((card.querySelector('[data-lj-variant].is-active') || {}).dataset || {}).variantId;
        var button = card.querySelector('[data-lj-choose]');
        var unavailable = card.dataset.available === 'false' || !Number(cardVariant || (button && button.dataset.variantId) || 0);
        var chosenCard = !!choice && String(cardVariant || (button && button.dataset.variantId) || '') === String(choice.variantId);
        card.classList.toggle('is-selected', chosenCard);
        if (button) {
          button.disabled = unavailable || (!!choice && !chosenCard);
          button.textContent = chosenCard ? 'SELECTED' : 'CHOOSE';
        }
      });
    }

    function openPicker(event) {
      if (!picker) return;
      activeSelector = event && event.currentTarget ? event.currentTarget : activeSelector;
      activeSlot = (activeSelector && activeSelector.dataset.ljSlot) || 'first';
      syncPicker(activeSlot);
      picker.hidden = false;
      selectors.forEach(function (selector) {
        selector.setAttribute('aria-expanded', selector === activeSelector ? 'true' : 'false');
      });
      lockPage(true);
      var close = picker.querySelector('[data-lj-close-picker]');
      if (close) close.focus();
    }

    function closePicker() {
      if (!picker) return;
      picker.hidden = true;
      selectors.forEach(function (selector) { selector.setAttribute('aria-expanded', 'false'); });
      lockPage(false);
      if (activeSelector && !activeSelector.hidden) activeSelector.focus();
    }

    function getOrganiserRefillInputs() {
      var formId = root.dataset.productFormId;
      return {
        variant: document.getElementById(formId + '-free-refill-variant'),
        title: document.getElementById(formId + '-free-refill-title'),
        price: document.getElementById(formId + '-free-refill-price'),
        paidVariant: document.getElementById(formId + '-plus-refill-variant'),
        paidTitle: document.getElementById(formId + '-plus-refill-title'),
        paidPrice: document.getElementById(formId + '-plus-refill-price'),
        source: document.getElementById(formId + '-refill-source')
      };
    }

    function writeOrganiserRefill(slot, choice) {
      if (slot !== 'first' && slot !== 'second') return;
      var inputs = getOrganiserRefillInputs();
      var fields = slot === 'second'
        ? [inputs.paidVariant, inputs.paidTitle, inputs.paidPrice]
        : [inputs.variant, inputs.title, inputs.price];
      var values = choice ? [choice.variantId, choice.title, choice.price] : ['', '', ''];
      fields.forEach(function (field, index) {
        if (field) field.value = values[index];
      });
      if (inputs.source) {
        if (choice) {
          inputs.source.value = 'lifestyle-journal';
        } else {
          var hasFirst = inputs.variant && inputs.variant.value;
          var hasSecond = inputs.paidVariant && inputs.paidVariant.value;
          if (!hasFirst && !hasSecond) inputs.source.value = '';
        }
      }
    }

    function clearOrganiserRefillInputs() {
      writeOrganiserRefill('first', null);
      writeOrganiserRefill('second', null);
    }

    function updateSelectedView(slot, choice) {
      var selected = getSelectedView(slot);
      var selector = getSelector(slot);
      if (!selected || !selector) return;
      selected.querySelector('[data-lj-selected-image]').src = choice.image;
      selected.querySelector('[data-lj-selected-image]').alt = choice.title;
      selected.querySelector('[data-lj-selected-title]').textContent = choice.title;
      selected.querySelector('[data-lj-selected-price]').textContent = mode === 'refill'
        ? money(choice.price)
        : money(Math.round(Number(choice.price) * 0.85)) + ' (15% off)';
      var quantity = selected.querySelector('[data-lj-choice-quantity]');
      if (quantity) quantity.value = choice.quantity || 1;
      selected.hidden = false;
      selector.hidden = true;
    }

    function setChoice(choice) {
      var slot = mode === 'refill' ? 'first' : activeSlot;
      choices[slot] = choice;
      if (slot === 'first') {
        root.dataset.ljSelectedVariant = choice.variantId;
        root.dataset.ljSelectedPrice = choice.price;
        root.dataset.ljSelectedTitle = choice.title;
      }
      updateSelectedView(slot, choice);
      if (mode === 'organiser') { writeOrganiserRefill(slot, choice); ensureAdditionalSlot(); }
      syncPicker(slot);
      closePicker();
    }

    function ensureAdditionalSlot() {
      if (mode !== 'organiser') return;
      if (Object.keys(choices).some(function (slot) { return slot !== 'first' && !choices[slot]; })) return;
      var template = getSelector('second').closest('.lj-pdp__journal-slot');
      var copy = template.cloneNode(true);
      var slot = 'additional-' + Object.keys(choices).length;
      choices[slot] = null;
      var button = copy.querySelector('[data-lj-open-picker]');
      button.dataset.ljSlot = slot;
      button.hidden = false;
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', openPicker);
      var selected = copy.querySelector('[data-lj-selected]');
      selected.dataset.ljSlotSelected = slot;
      selected.hidden = true;
      var remove = copy.querySelector('[data-lj-remove]');
      remove.dataset.ljSlot = slot;
      remove.addEventListener('click', function () { clearChoice(slot); });
      selectors.push(button);
      template.parentNode.appendChild(copy);
    }

    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-lj-choice-quantity]')) return;
      var selected = event.target.closest('[data-lj-slot-selected]');
      var choice = selected && choices[selected.dataset.ljSlotSelected];
      if (choice) choice.quantity = Number(event.target.value);
    });

    function clearChoice(slot) {
      slot = slot || 'first';
      choices[slot] = null;
      if (slot === 'first') {
        delete root.dataset.ljSelectedVariant;
        delete root.dataset.ljSelectedPrice;
        delete root.dataset.ljSelectedTitle;
      }
      var selected = getSelectedView(slot);
      var selector = getSelector(slot);
      if (selected) selected.hidden = true;
      if (selector) selector.hidden = false;
      if (mode === 'organiser') writeOrganiserRefill(slot, null);
      syncPicker(slot);
    }

    function getPlanningControl(slot) {
      return root.querySelector('[data-lj-open-planning-picker][data-lj-planning-slot="' + slot + '"]');
    }

    function getPlanningSelectedView(slot) {
      return root.querySelector('[data-lj-planning-selected][data-lj-planning-slot-selected="' + slot + '"]');
    }

    function getPlanningNativeSlot(slot) {
      var planning = document.querySelector('[data-lj-planning-refills]');
      return planning && planning.querySelector(slot === 'second' ? '.refillSlot--plus' : '.refillSlot--free');
    }

    function getPlanningChoice(slot) {
      var inputs = getOrganiserRefillInputs();
      var variant = slot === 'second' ? inputs.paidVariant : inputs.variant;
      var title = slot === 'second' ? inputs.paidTitle : inputs.title;
      var price = slot === 'second' ? inputs.paidPrice : inputs.price;
      var nativeSlot = getPlanningNativeSlot(slot);
      var image = nativeSlot && nativeSlot.querySelector('.refillSlotImg');
      if (!variant || !variant.value) return null;
      return {
        variantId: variant.value,
        title: (title && title.value) || 'Planning Refill',
        price: Number((price && price.value) || 0),
        image: (image && image.src) || ''
      };
    }

    function syncPlanningChoice(slot) {
      var control = getPlanningControl(slot);
      var selected = getPlanningSelectedView(slot);
      var choice = getPlanningChoice(slot);
      if (!control || !selected) return;
      control.hidden = !!choice;
      selected.hidden = !choice;
      if (!choice) return;
      var image = selected.querySelector('[data-lj-selected-image]');
      image.src = choice.image;
      image.alt = choice.title;
      selected.querySelector('[data-lj-selected-title]').textContent = choice.title;
      selected.querySelector('[data-lj-selected-price]').textContent = money(Math.round(choice.price * (slot === 'second' ? planningSecondMultiplier : 0.8))) + (slot === 'second' ? ' (' + planningSecondDiscount + '% off)' : ' (20% off)');
    }

    function clearPlanningChoice(slot) {
      writeOrganiserRefill(slot, null);
      var nativeSlot = getPlanningNativeSlot(slot);
      if (nativeSlot) {
        nativeSlot.classList.remove('is-filled');
        if (slot === 'second') nativeSlot.classList.remove('is-visible');
        var image = nativeSlot.querySelector('.refillSlotImg');
        if (image) {
          image.removeAttribute('src');
          image.style.display = 'none';
        }
        var caption = nativeSlot.querySelector('.refillSlotCaption');
        if (caption) caption.remove();
        var meta = nativeSlot.querySelector('[data-meta-' + (slot === 'second' ? 'plus' : 'free') + ']');
        if (meta) meta.style.display = 'none';
      }
      if (slot === 'first') clearPlanningChoice('second');
      syncPlanningChoice(slot);
    }

    function openPlanningPicker(event) {
      var slot = event.currentTarget.dataset.ljPlanningSlot || 'first';
      var nativeSlot = getPlanningNativeSlot(slot);
      var nativeOpen = nativeSlot && nativeSlot.querySelector('[data-open-picker]');
      if (!nativeOpen) return;
      event.currentTarget.setAttribute('aria-expanded', 'true');
      nativeOpen.click();
    }

    selectors.forEach(function (selector) { selector.addEventListener('click', openPicker); });
    if (picker.querySelector('[data-lj-close-picker]')) picker.querySelector('[data-lj-close-picker]').addEventListener('click', closePicker);
    root.querySelectorAll('[data-lj-remove]').forEach(function (button) {
      button.addEventListener('click', function () { clearChoice(button.dataset.ljSlot || 'first'); });
    });
    root.querySelectorAll('[data-lj-open-planning-picker]').forEach(function (button) {
      button.addEventListener('click', openPlanningPicker);
    });
    root.querySelectorAll('[data-lj-remove-planning]').forEach(function (button) {
      button.addEventListener('click', function () { clearPlanningChoice(button.dataset.ljPlanningSlot || 'first'); });
    });

    if (mode === 'organiser') {
      var organiserInputs = getOrganiserRefillInputs();
      [organiserInputs.variant, organiserInputs.paidVariant].forEach(function (input, index) {
        if (!input) return;
        input.addEventListener('change', function () {
          window.setTimeout(function () { syncPlanningChoice(index === 0 ? 'first' : 'second'); }, 0);
        });
      });
    }

    function getMatchingSwatch(card, colour) {
      return Array.prototype.slice.call(card.querySelectorAll('[data-lj-variant]')).find(function (swatch) {
        return colourValuesMatch(swatch.getAttribute('aria-label') || '', colour);
      });
    }

    function updateCardVariant(card, swatch) {
      if (!card || !swatch || !swatch.dataset.variantId) return;

      card.querySelectorAll('[data-lj-variant]').forEach(function (item) {
        var active = item === swatch;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      card.dataset.selectedVariantId = swatch.dataset.variantId;
      card.dataset.selectedVariantTitle = swatch.dataset.variantTitle;
      card.dataset.selectedVariantPrice = swatch.dataset.variantPrice;
      card.dataset.selectedVariantPriceDisplay = swatch.dataset.variantPriceDisplay;
      card.dataset.selectedVariantImage = swatch.dataset.variantImage;

      var cardPrice = card.querySelector('[data-lj-card-price]');
      var cardImage = card.querySelector('.lj-pdp-card__image img');
      var image320 = swatch.getAttribute('data-variant-image-320') || '';
      var image480 = swatch.getAttribute('data-variant-image-480') || '';
      var image700 = swatch.getAttribute('data-variant-image-700') || swatch.dataset.variantImage || '';
      if (cardPrice) cardPrice.textContent = swatch.dataset.variantPriceDisplay || money(swatch.dataset.variantPrice);
      if (cardImage && image700) {
        cardImage.src = image700;
        if (image320 && image480) {
          cardImage.srcset = image320 + ' 320w, ' + image480 + ' 480w, ' + image700 + ' 700w';
          cardImage.sizes = '(max-width: 700px) 50vw, 25vw';
        } else {
          cardImage.removeAttribute('srcset');
          cardImage.removeAttribute('sizes');
        }
        cardImage.alt = swatch.dataset.variantTitle || '';
      }

      var variantUrl = swatch.dataset.variantUrl || '';
      var imageLink = card.querySelector('[data-lj-card-image-link]');
      var viewLink = card.querySelector('[data-lj-card-view]');
      if (variantUrl && imageLink) imageLink.href = variantUrl;
      if (variantUrl && viewLink) viewLink.href = variantUrl;
    }

    picker.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-lj-variant]');
      if (swatch) {
        var swatchCard = swatch.closest('[data-lj-card]');
        // The filter describes colours the organiser offers; a manual swatch preview should not clear it.
        updateCardVariant(swatchCard, swatch);
        return;
      }

      var card = event.target.closest('[data-lj-card]');
      if (!card) return;
      var choose = event.target.closest('[data-lj-choose]');
      if (!choose) {
        if (event.target.closest('a, button, input, select, textarea, [role="button"], [role="radio"]')) return;
        choose = card.querySelector('[data-lj-choose]');
      }
      if (!choose || choose.disabled) return;
      var activeVariant = card.querySelector('[data-lj-variant].is-active');
      var source = choose.dataset.variantId ? choose : (activeVariant || {});
      if (!source.dataset || !source.dataset.variantId) return;
      setChoice({
        variantId: card.dataset.selectedVariantId || source.dataset.variantId,
        title: card.dataset.selectedVariantTitle || source.dataset.variantTitle,
        price: card.dataset.selectedVariantPrice || source.dataset.variantPrice,
        image: card.dataset.selectedVariantImage || source.dataset.variantImage || (card.querySelector('img') && card.querySelector('img').src) || ''
      });
    });

    picker.querySelectorAll('[data-lj-filter-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var name = toggle.dataset.ljFilterToggle;
        picker.querySelectorAll('[data-lj-filter-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.ljFilterPanel !== name || !panel.hidden;
        });
        picker.querySelectorAll('[data-lj-filter-toggle]').forEach(function (item) {
          var panel = picker.querySelector('[data-lj-filter-panel="' + name + '"]');
          var active = item === toggle && panel && !panel.hidden;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-expanded', active ? 'true' : 'false');
        });
      });
    });

    var activePrice = null;
    var activeColour = '';
    var filterCards = uniqueProductCards(picker.querySelectorAll('[data-lj-card]'));
    var colourButtons = Array.prototype.slice.call(picker.querySelectorAll('[data-lj-colour]'));

    function cardIsAvailable(card) {
      return card.dataset.available !== 'false' || card.dataset.previewOnly === 'true';
    }

    function cardMatchesPrice(card) {
      if (!activePrice) return true;
      var colourSwatch = activeColour && getMatchingSwatch(card, activeColour);
      var price = Number((colourSwatch && colourSwatch.dataset.variantPrice) || card.dataset.selectedVariantPrice || card.dataset.price || 0);
      return price >= activePrice.min && (activePrice.max === null || price <= activePrice.max);
    }

    function cardColourValue(card) {
      var availableSwatches = Array.prototype.slice.call(card.querySelectorAll('[data-lj-variant]')).filter(function (swatch) {
        return swatch.getAttribute('aria-label');
      });
      var filterColours = card.dataset.filterColours || '';
      if (availableSwatches.length) {
        return availableSwatches.map(function (swatch) { return swatch.getAttribute('aria-label'); }).join('|') + (filterColours ? '|' + filterColours : '');
      }
      return filterColours || card.dataset.availableColours || card.dataset.colours || '';
    }

    function cardMatchesColour(card, colour) {
      return !colour || colourValuesMatch(cardColourValue(card), colour);
    }

    function updateColourOptions() {
      colourButtons.forEach(function (button) {
        button.hidden = !filterCards.some(function (card) {
          return cardIsAvailable(card) && cardMatchesPrice(card) && cardMatchesColour(card, button.dataset.ljColour || '');
        });
      });

      if (!activeColour) return;
      var activeButton = colourButtons.find(function (button) {
        return button.dataset.ljColour === activeColour;
      });
      if (activeButton && !activeButton.hidden) return;
      activeColour = '';
      colourButtons.forEach(function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
    }

    function syncCardsToColour() {
      if (!activeColour) return;
      filterCards.forEach(function (card) {
        if (!cardIsAvailable(card) || !cardMatchesPrice(card) || !cardMatchesColour(card, activeColour)) return;
        var matchingSwatch = getMatchingSwatch(card, activeColour);
        if (matchingSwatch) updateCardVariant(card, matchingSwatch);
      });
    }

    function applyFilters() {
      updateColourOptions();
      var shown = 0;
      filterCards.forEach(function (card) {
        var matches = cardIsAvailable(card) && cardMatchesPrice(card) && cardMatchesColour(card, activeColour);
        card.hidden = !matches;
        if (!card.hidden) shown += 1;
      });
      var empty = picker.querySelector('[data-lj-picker-empty]');
      if (empty) empty.hidden = shown !== 0;
    }

    picker.querySelectorAll('[data-lj-price-min]').forEach(function (button) {
      button.addEventListener('click', function () {
        var alreadyActive = button.classList.contains('is-active');
        picker.querySelectorAll('[data-lj-price-min]').forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        activePrice = alreadyActive ? null : {
          min: Number(button.dataset.ljPriceMin || 0),
          max: button.hasAttribute('data-lj-price-max') ? Number(button.dataset.ljPriceMax) : null
        };
        button.classList.toggle('is-active', !alreadyActive);
        button.setAttribute('aria-pressed', alreadyActive ? 'false' : 'true');
        applyFilters();
      });
    });

    colourButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var alreadyActive = button.classList.contains('is-active');
        colourButtons.forEach(function (item) { item.classList.remove('is-active'); });
        activeColour = alreadyActive ? '' : button.dataset.ljColour;
        button.classList.toggle('is-active', !alreadyActive);
        colourButtons.forEach(function (item) {
          item.setAttribute('aria-pressed', item === button && !alreadyActive ? 'true' : 'false');
        });
        if (activeColour) syncCardsToColour();
        applyFilters();
      });
    });

    filterCards.forEach(function (card) {
      var initialSwatch = card.querySelector('[data-lj-variant].is-active') || card.querySelector('[data-lj-variant]');
      if (initialSwatch) updateCardVariant(card, initialSwatch);
    });
    applyFilters();

    function clearOrganiserPathSelections() {
      Object.keys(choices).forEach(function (slot) { clearChoice(slot); });
      clearPlanningChoice('first');
      clearOrganiserRefillInputs();
    }

    function setActiveOrganiserPath(value) {
      if (mode !== 'organiser' || !value || root.dataset.ljActivePath === value) return;

      clearOrganiserPathSelections();
      root.dataset.ljActivePath = value;

      root.querySelectorAll('.lj-pdp__path[data-lj-path]').forEach(function (path) {
        var active = path.dataset.ljPath === value;
        path.classList.toggle('is-active', active);
        path.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var lifestyleChoice = root.querySelector('[data-lj-lifestyle-choice]');
      var planningChoice = root.querySelector('[data-lj-planning-choice]');
      var dyorEntry = root.querySelector('[data-lj-dyor-entry]');
      if (lifestyleChoice) lifestyleChoice.hidden = value !== 'lifestyle';
      if (planningChoice) planningChoice.hidden = value !== 'planning';
      if (dyorEntry) {
        dyorEntry.hidden = value !== 'dyor';
        dyorEntry.setAttribute('aria-expanded', value === 'dyor' ? 'true' : 'false');
      }
    }

    root.querySelectorAll('.lj-pdp__path[data-lj-path]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setActiveOrganiserPath(trigger.dataset.ljPath);
      });
    });

    var dyorEntry = root.querySelector('[data-lj-dyor-entry]');
    if (dyorEntry) {
      dyorEntry.addEventListener('click', function () {
        if (root.dataset.ljActivePath !== 'dyor') return;
        var planning = document.querySelector('[data-lj-planning-refills]');
        var nativeEntry = planning && planning.querySelector('[data-dyor-organiser-entry]');
        if (nativeEntry) nativeEntry.click();
      });
    }

    if (mode === 'organiser') {
      var organiserForm = document.getElementById(root.dataset.productFormId);

      function organiserPathValidationMessage() {
        var path = root.dataset.ljActivePath || '';
        if (!path) return 'Please choose one of the organizer options before adding to your cart.';

        if (path === 'planning' || path === 'lifestyle') {
          var inputs = getOrganiserRefillInputs();
          if (!inputs.variant || !inputs.variant.value) {
            return path === 'planning'
              ? 'Please choose your first Planning Refill before adding to your cart.'
              : 'Please choose your first Lifestyle Journal Refill before adding to your cart.';
          }
        }

        if (path === 'dyor') return 'Please select “Start designing now” to create your refill.';
        return '';
      }

      function submitLifestyleOrganiser(event) {
        if (root.dataset.ljActivePath !== 'lifestyle') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (organiserForm.dataset.ljSubmitting === 'true') return;
        var idInput = organiserForm.querySelector('[name="id"], .original-selector');
        var variantId = Number(idInput && idInput.value || root.dataset.mainVariantId);
        var quantityInput = organiserForm.querySelector('[name="quantity"]');
        var quantity = Number(quantityInput && quantityInput.value || 1);
        var price = Number(root.dataset.mainPrice);
        try {
          var product = JSON.parse(document.querySelector('[id^="ProductJson-"]').textContent);
          var variant = product.variants.find(function (item) { return Number(item.id) === variantId; });
          if (variant) price = Number(variant.price);
        } catch (ignore) {}
        var properties = {};
        new FormData(organiserForm).forEach(function (value, key) {
          var match = key.match(/^properties\[(.+)\]$/);
          if (match && String(value)) properties[match[1]] = String(value);
        });
        var refills = Object.keys(choices).map(function (slot) { return choices[slot]; }).filter(Boolean).map(function (choice) {
          return { variantId: choice.variantId, price: Number(choice.price), title: choice.title, quantity: Number(choice.quantity === undefined ? 1 : choice.quantity) * quantity };
        });
        var buttons = organiserForm.querySelectorAll('.addToCart, button[type="submit"]');
        organiserForm.dataset.ljSubmitting = 'true';
        buttons.forEach(function (button) { button.disabled = true; });
        addLifestyle({ organizer: { variantId: variantId, price: price, quantity: quantity, title: root.dataset.mainTitle || 'A5 Organizer', properties: properties }, refills: refills }).then(function () {
          notifyCartChanged();
          window.location.assign((window.Shopify && Shopify.routes.root || '/') + 'cart');
        }).catch(function (error) { window.alert(error.message); }).finally(function () {
          delete organiserForm.dataset.ljSubmitting;
          buttons.forEach(function (button) { button.disabled = false; });
        });
      }

      function stopInvalidOrganiserAdd(event) {
        var message = organiserPathValidationMessage();
        if (!message) return false;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.alert(message);
        return true;
      }

      document.addEventListener('click', function (event) {
        if (!organiserForm || !event.target.closest) return;
        var addButton = event.target.closest('.addToCart, button[type="submit"]');
        if (!addButton || !organiserForm.contains(addButton)) return;
        if (!stopInvalidOrganiserAdd(event)) submitLifestyleOrganiser(event);
      }, true);

      if (organiserForm) {
        organiserForm.addEventListener('submit', function (event) {
          if (!stopInvalidOrganiserAdd(event)) submitLifestyleOrganiser(event);
        }, true);
      }
    }

    if (mode === 'refill') {
      var form = document.getElementById(root.dataset.productFormId);
      var success = root.querySelector('[data-lj-success]');
      var standaloneOffer = null;

      function showSuccess(modeName) {
        openSuccess(success, modeName);
        lockPage(true);
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          var currentChoice = choices.first;
          if (form.dataset.ljSubmitting === 'true') {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();

          var idField = form.querySelector('[name="id"]');
          var quantityField = form.querySelector('[name="quantity"]');
          var refillVariantId = Number(idField && idField.value ? idField.value : root.dataset.mainVariantId);
          var quantity = Math.max(1, Number(quantityField && quantityField.value ? quantityField.value : 1));
          var refillPrice = Number(root.dataset.mainPrice || 0);
          try {
            var productJson = JSON.parse(document.querySelector('[id^="ProductJson-"]').textContent || '{}');
            var selectedVariant = (productJson.variants || []).find(function (variant) { return Number(variant.id) === refillVariantId; });
            if (selectedVariant) refillPrice = Number(selectedVariant.price);
          } catch (ignore) {}

          var refillTitleNode = document.querySelector('.product-form .title');
          var refillTitle = refillTitleNode ? refillTitleNode.textContent.trim() : 'Lifestyle Journal Refill';
          var button = form.querySelector('[type="submit"]');
          form.dataset.ljSubmitting = 'true';
          if (button) {
            button.disabled = true;
            button.classList.add('loading');
          }

          if (!currentChoice) {
            addLifestyle({ refills: [{ variantId: refillVariantId, quantity: quantity, price: refillPrice, title: refillTitle }] }).then(function (response) {
              standaloneOffer = true;
              showSuccess('refill-only');
              notifyCartChanged();
              document.dispatchEvent(new CustomEvent('lj:cart:add', { detail: { refillOnly: true } }));
            }).catch(function () {
              window.alert('Sorry, something went wrong adding your refill. Please try again.');
            }).finally(function () {
              delete form.dataset.ljSubmitting;
              if (button) {
                button.disabled = false;
                button.classList.remove('loading');
              }
            });
            return;
          }

          var organiserVariantId = Number(currentChoice.variantId);
          var organiserPrice = Number(currentChoice.price || 0);
          var organiserTitle = currentChoice.title || 'A5 Organizer';
          var refillNow = Math.round(refillPrice * 0.85);
          var bundleWas = organiserPrice + (refillPrice * quantity);
          var bundleNow = organiserPrice + (refillNow * quantity);
          var discount = bundleWas > 0 ? Number((((bundleWas - bundleNow) / bundleWas) * 100).toFixed(4)) : 0;
          var bundleId = 'lj_' + Date.now() + '_' + Math.round(Math.random() * 1000000);

          addLifestyle({
            organizer: { variantId: organiserVariantId, quantity: 1, price: organiserPrice, title: organiserTitle },
            refills: [{ variantId: refillVariantId, quantity: quantity, price: refillPrice, title: refillTitle }]
          }).then(function () {
            standaloneOffer = true;
            showSuccess('bundle');
            notifyCartChanged();
          }).catch(function () {
            window.alert('Sorry, something went wrong adding your bundle. Please try again.');
          }).finally(function () {
            delete form.dataset.ljSubmitting;
            if (button) {
              button.disabled = false;
              button.classList.remove('loading');
            }
          });
        }, true);
      }

      if (success) {
        success.addEventListener('click', function (event) {
          var link = event.target.closest('[data-lj-second-refill]');
          if (!link || !success.contains(link) || !standaloneOffer) return;
          event.preventDefault();
          if (success.dataset.ljAddingSecond === 'true') return;

          var second = {
            variantId: Number(link.dataset.variantId || 0),
            price: Number(link.dataset.price || 0),
            title: link.dataset.title || link.textContent.trim()
          };
          if (link.dataset.available === 'false' || !second.variantId || !second.price) {
            window.alert('Sorry, this Lifestyle Journal Refill is currently unavailable.');
            return;
          }

          var label = link.querySelector('span');
          var originalLabel = label ? label.textContent : '';
          success.dataset.ljAddingSecond = 'true';
          success.classList.add('is-adding');
          link.classList.add('is-adding');
          link.setAttribute('aria-busy', 'true');
          if (label) label.textContent = 'ADDING…';

          addLifestyle({ refills: [second] }).then(function () {
            var status = success.querySelector('[data-lj-success-status]');
            if (status) status.textContent = 'Added to your cart. Choose another journal or view your cart.';
            notifyCartChanged();
            document.dispatchEvent(new CustomEvent('lj:cart:add', { detail: { discountedSecondRefill: true } }));

          }).catch(function (error) {
            window.alert(error.message || 'Sorry, the additional refill could not be added. Please try again.');
          }).finally(function () {
            success.dataset.ljAddingSecond = 'false';
            success.classList.remove('is-adding');
            link.classList.remove('is-adding');
            link.removeAttribute('aria-busy');
            if (label) label.textContent = originalLabel;
          });
        });
      }

      root.querySelectorAll('[data-lj-success-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          root.querySelector('[data-lj-success]').hidden = true;
          lockPage(false);
        });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (picker && !picker.hidden) closePicker();
      var success = root.querySelector('[data-lj-success]');
      if (success && !success.hidden) {
        success.hidden = true;
        lockPage(false);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-lj-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
